const React = require('react');
const { default: Styled } = require('styled-components');
const { transient$Props } = require('utils/styles');

const internals = {};

module.exports = function FieldGrid(props) {
    const GridRoot = internals.getGridRoot();

    const {
        children,
        columns = 2,
        columnGap,
        gap,
        rowGap,
        singleRowMinHeight = 48
    } = props;

    const resolvedRowGap = typeof rowGap === 'undefined'
        ? (typeof gap === 'undefined' ? 2 : gap)
        : rowGap;
    const resolvedColumnGap = typeof columnGap === 'undefined'
        ? (typeof gap === 'undefined' ? 2 : gap)
        : columnGap;

    return <GridRoot
        $columns={columns}
        $columnGap={resolvedColumnGap}
        $rowGap={resolvedRowGap}
        $singleRowMinHeight={singleRowMinHeight}
    >
        {children}
    </GridRoot>;
};

internals.GridRoot = Styled.div.withConfig(transient$Props)`
    display: grid;
    grid-auto-flow: row dense;
    grid-template-columns: minmax(0, 1fr);
    align-items: flex-start;
    row-gap: ${({ theme, $rowGap }) => theme.spacing($rowGap)};
    column-gap: ${({ theme, $columnGap }) => theme.spacing($columnGap)};
    min-height: ${({ $singleRowMinHeight }) => $singleRowMinHeight}px;

    @media (min-width: 600px) {
        grid-template-columns: repeat(${({ $columns }) => Math.max(1, Number($columns) || 1)}, minmax(0, 1fr));
    }
`;

internals.getGridRoot = () => internals.GridRoot;

module.exports.internals = internals;
